import { prop } from 'ramda';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getCleanPath } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';
import { useNavigate } from 'js/hooks/navigate/useNavigate';

export const useForwardRootPage = ({ page }) => {
    const navigateWithReplace = useNavigate({ replace: true });
    const rootPage = useAppSelector(prop('rootPage'));
    const location = useLocation();

    useEffect(() => {
        if (!page || getCleanPath(location.pathname) !== '/') {
            return;
        }

        const { friendlyURL } = page;

        if (friendlyURL === '') {
            navigateWithReplace(rootPage);
        }
    }, [rootPage, navigateWithReplace, page, location]);
};
